'use strict';
; (function () {
    angular.module("EMR.SelectInsuranceNamePopupModule", []);

    var SelectInsuranceNamePopupModuleRoutes = [
        {
            name: "SelectInsuranceName",
            url: "SelectInsuranceName",
            "directivescontrollersFiles": "",
            "RoutingNumber": 4655,
            templateUrl: "AngularScripts/SelectInsuranceName/Htmls/SelectInsuranceNamePopup.html",
            files: [
                "AngularScripts/SelectInsuranceName/Services/SelectInsuranceNameService.js",
                "AngularScripts/SelectInsuranceName/Controllers/SelectInsuranceNamePopupController.js",
                "AngularScripts/EhrAgGridHandler/Factories/EhrAgGridHandlerFactory.js",
            ]
        },
    ]
    angular.module('EMR.SelectInsuranceNamePopupModule')
        .constant("SelectInsuranceNamePopupModuleRoutes", SelectInsuranceNamePopupModuleRoutes)
        .config(["$stateProvider", "EmrRouteProvider", "SelectInsuranceNamePopupModuleRoutes",
            function ($stateProvider, EmrRouteProvider, SelectInsuranceNamePopupModuleRoutes) {
                EmrRouteProvider.registerStates(SelectInsuranceNamePopupModuleRoutes, $stateProvider);
            }]);
})();

